export default "__VITE_ASSET__BCcFDP13__"